(function () {
  'use strict';

  var root = document.querySelector('.pp-invoice-snap');
  if (!root) return;

  var form = document.getElementById('pp-invoice-snap-form');
  var venueInput = document.getElementById('pp-snap-venue');
  var noteInput = document.getElementById('pp-snap-note');
  var honeypot = document.getElementById('pp-company-website');
  var video = document.getElementById('pp-snap-video');
  var canvas = document.getElementById('pp-snap-canvas');
  var shutter = document.getElementById('pp-snap-shutter');
  var fallback = document.getElementById('pp-snap-fallback');
  var dropzone = document.getElementById('pp-snap-drop');
  var filesBtn = document.getElementById('pp-snap-files');
  var clearBtn = document.getElementById('pp-snap-clear');
  var takePhotoBtn = document.getElementById('pp-snap-take-photo');
  var filesInput = document.getElementById('pp-snap-input-files');
  var captureInput = document.getElementById('pp-snap-input-capture');
  var previews = document.getElementById('pp-snap-previews');
  var countEl = document.getElementById('pp-snap-count');
  var statusEl = document.getElementById('pp-snap-status');
  var submitBtn = document.getElementById('pp-snap-submit');
  var review = document.getElementById('pp-snap-review');
  var reviewImg = document.getElementById('pp-snap-review-img');
  var reviewKeep = document.getElementById('pp-snap-review-keep');
  var reviewRetake = document.getElementById('pp-snap-review-retake');

  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var maxFiles = parseInt(root.getAttribute('data-max-files') || '20', 10) || 20;

  var files = [];
  var stream = null;
  var snapping = false;
  var cameraWatchTimer = null;
  var pendingBlob = null;
  var pendingUrl = null;
  var autoOpenCamera = false;
  var liveCameraOk = false;

  var MAX_EDGE = 1600;
  var JPEG_Q = 0.72;

  function isPhoneMode() {
    var ua = navigator.userAgent || '';
    var mobileUa = /Android|iPhone|iPod|iPad|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    var coarse = false;
    try {
      coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    } catch (e) {}
    var touch = (navigator.maxTouchPoints || 0) > 0 || 'ontouchstart' in window;
    var narrow = false;
    try {
      narrow = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    } catch (e2) {
      narrow = window.innerWidth < 768;
    }
    if (touch && (mobileUa || coarse || narrow)) return true;
    if (mobileUa && narrow) return true;
    return false;
  }

  var isPhone = isPhoneMode();
  root.classList.remove('is-desktop', 'is-phone');
  root.classList.add(isPhone ? 'is-phone' : 'is-desktop');

  function isAllowedFile(f) {
    if (!f) return false;
    var t = (f.type || '').toLowerCase();
    if (t.indexOf('image/') === 0) return true;
    if (t === 'application/pdf') return true;
    var n = (f.name || '').toLowerCase();
    return n.slice(-4) === '.pdf';
  }

  function setStatus(msg, kind) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.className = 'pp-invoice-snap__status' + (kind ? ' is-' + kind : '');
  }

  function updateChrome() {
    var n = files.length;
    if (countEl) countEl.textContent = n === 1 ? '1 file queued' : n + ' files queued';
    if (submitBtn) submitBtn.disabled = n === 0;
    if (clearBtn) clearBtn.hidden = n === 0;
    if (shutter) shutter.disabled = !liveCameraOk || !stream || n >= maxFiles || snapping || !!pendingBlob;
  }

  function compressImageFile(file) {
    return new Promise(function (resolve) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) {
        resolve(file);
        return;
      }
      if (file.size && file.size < 350000 && file.type === 'image/jpeg') {
        resolve(file);
        return;
      }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        var scale = 1;
        var longEdge = Math.max(w, h);
        if (longEdge > MAX_EDGE) scale = MAX_EDGE / longEdge;
        var cw = Math.max(1, Math.round(w * scale));
        var ch = Math.max(1, Math.round(h * scale));
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        c.getContext('2d').drawImage(img, 0, 0, cw, ch);
        var finish = function (blob) {
          if (!blob) {
            resolve(file);
            return;
          }
          var name = (file.name || 'invoice.jpg').replace(/\.[^.]+$/, '') + '.jpg';
          try {
            resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
          } catch (e) {
            blob.name = name;
            resolve(blob);
          }
        };
        if (c.toBlob) c.toBlob(finish, 'image/jpeg', JPEG_Q);
        else {
          fetch(c.toDataURL('image/jpeg', JPEG_Q))
            .then(function (r) { return r.blob(); })
            .then(finish)
            .catch(function () { resolve(file); });
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  try {
    var params = new URLSearchParams(window.location.search);
    var venueQ = params.get('venue');
    if (venueQ && venueInput && !venueInput.value) venueInput.value = venueQ;
  } catch (e) {}

  function renderPreviews() {
    if (!previews) return;
    previews.innerHTML = '';
    files.forEach(function (file, index) {
      var li = document.createElement('li');
      var isPdf = (file.type || '') === 'application/pdf' || /\.pdf$/i.test(file.name || '');
      if (isPdf) {
        var badge = document.createElement('span');
        badge.className = 'pp-invoice-snap__pdf';
        badge.textContent = 'PDF';
        li.appendChild(badge);
      } else {
        var img = document.createElement('img');
        img.alt = 'Invoice ' + (index + 1);
        var url = URL.createObjectURL(file);
        img.src = url;
        img.onload = function () { URL.revokeObjectURL(url); };
        li.appendChild(img);
      }
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'pp-invoice-snap__remove';
      rm.setAttribute('aria-label', 'Remove photo');
      rm.textContent = '\u00d7';
      rm.addEventListener('click', function () {
        files.splice(index, 1);
        renderPreviews();
        updateChrome();
      });
      li.appendChild(rm);
      previews.appendChild(li);
    });
    updateChrome();
    if (files.length) previews.scrollLeft = previews.scrollWidth;
  }

  function pushFile(file) {
    if (files.length >= maxFiles) {
      setStatus('Maximum ' + maxFiles + ' files for one send.', 'error');
      updateChrome();
      return false;
    }
    files.push(file);
    setStatus('');
    renderPreviews();
    return true;
  }

  function addFiles(fileList) {
    if (!fileList || !fileList.length) return;
    var next = Array.prototype.slice.call(fileList).filter(isAllowedFile);
    if (!next.length) {
      setStatus('Photos or PDFs only.', 'error');
      return;
    }
    var room = maxFiles - files.length;
    if (room <= 0) {
      setStatus('Maximum ' + maxFiles + ' files for one send.', 'error');
      return;
    }
    var slice = next.slice(0, room);
    setStatus('Preparing files\u2026');
    Promise.all(slice.map(compressImageFile)).then(function (compressed) {
      compressed.forEach(function (f) { files.push(f); });
      if (next.length > room) setStatus('Only kept up to ' + maxFiles + ' files.', 'error');
      else setStatus('');
      renderPreviews();
    });
  }

  function clearPendingReview() {
    pendingBlob = null;
    if (pendingUrl) {
      URL.revokeObjectURL(pendingUrl);
      pendingUrl = null;
    }
    if (review) review.hidden = true;
    if (reviewImg) reviewImg.removeAttribute('src');
    updateChrome();
  }

  function showReviewFromBlob(blob) {
    if (!blob) return;
    clearPendingReview();
    pendingBlob = blob;
    pendingUrl = URL.createObjectURL(blob);
    if (reviewImg) reviewImg.src = pendingUrl;
    if (review) review.hidden = false;
    if (shutter) shutter.disabled = true;
    setStatus('Keep this photo or retake.');
  }

  function openNativeCamera() {
    if (!captureInput) return;
    if (files.length >= maxFiles) {
      setStatus('Maximum ' + maxFiles + ' files for one send.', 'error');
      autoOpenCamera = false;
      return;
    }
    captureInput.value = '';
    captureInput.click();
  }

  function afterKeepContinueShooting() {
    if (files.length >= maxFiles) {
      autoOpenCamera = false;
      setStatus('Maximum ' + maxFiles + ' files queued \u2014 tap Send when ready.', 'ok');
      return;
    }
    if (liveCameraOk && stream) {
      setStatus('Ready for next invoice \u2014 tap the shutter.');
      updateChrome();
      return;
    }
    autoOpenCamera = true;
    setStatus('Opening camera for next photo\u2026');
    setTimeout(function () {
      if (autoOpenCamera) openNativeCamera();
    }, 350);
  }

  function keepPending() {
    if (!pendingBlob) return;
    var blob = pendingBlob;
    clearPendingReview();
    var name = 'invoice-' + Date.now() + '.jpg';
    var file;
    try {
      file = new File([blob], name, { type: blob.type || 'image/jpeg', lastModified: Date.now() });
    } catch (e) {
      file = blob;
      file.name = name;
    }
    compressImageFile(file).then(function (compressed) {
      if (!pushFile(compressed)) return;
      afterKeepContinueShooting();
    });
  }

  function retakePending() {
    clearPendingReview();
    if (liveCameraOk && stream) {
      setStatus('Retake \u2014 line up the invoice and tap the shutter.');
      updateChrome();
      return;
    }
    autoOpenCamera = true;
    openNativeCamera();
  }

  function prepareVideoEl() {
    if (!video) return;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('muted', '');
    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
  }

  function showNativeFallback(msg) {
    liveCameraOk = false;
    if (fallback) {
      fallback.hidden = false;
      var p = fallback.querySelector('[data-fallback-msg]') || fallback.querySelector('p');
      if (p) p.textContent = msg || 'Use Start camera to open your camera.';
    }
    if (takePhotoBtn) takePhotoBtn.hidden = false;
    if (shutter) {
      shutter.hidden = true;
      shutter.disabled = true;
    }
    updateChrome();
  }

  function hideNativeFallback() {
    if (fallback) fallback.hidden = true;
    // Keep Start camera visible — native capture is the reliable phone path
    if (takePhotoBtn) takePhotoBtn.hidden = false;
    if (shutter) shutter.hidden = false;
  }

  function clearCameraWatch() {
    if (cameraWatchTimer) {
      clearTimeout(cameraWatchTimer);
      cameraWatchTimer = null;
    }
  }

  function watchVideoSize() {
    clearCameraWatch();
    cameraWatchTimer = setTimeout(function () {
      cameraWatchTimer = null;
      if (!stream) return;
      var w = video && video.videoWidth;
      var h = video && video.videoHeight;
      if (!w || !h) {
        stopLiveCamera();
        showNativeFallback('Live preview didn\u2019t start. Tap Start camera to use your phone camera.');
      }
    }, 2200);
  }

  function stopLiveCamera() {
    clearCameraWatch();
    liveCameraOk = false;
    if (stream) {
      stream.getTracks().forEach(function (t) { t.stop(); });
      stream = null;
    }
    if (video) video.srcObject = null;
  }

  function attachStream(mediaStream) {
    stream = mediaStream;
    liveCameraOk = true;
    prepareVideoEl();
    video.srcObject = mediaStream;
    hideNativeFallback();
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
    watchVideoSize();
    updateChrome();
    setStatus('Line up the invoice, tap the shutter, then tick to keep.');
  }

  function startLiveCamera() {
    if (!isPhone) return;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      showNativeFallback('Camera API not available. Tap Start camera.');
      return;
    }
    prepareVideoEl();
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1920 },
          height: { ideal: 1440 },
        },
      })
      .then(attachStream)
      .catch(function () {
        return navigator.mediaDevices
          .getUserMedia({ audio: false, video: { facingMode: 'environment' } })
          .then(attachStream);
      })
      .catch(function () {
        showNativeFallback(
          'Couldn\u2019t open live camera. Tap Start camera \u2014 it will reopen after each keep.'
        );
      });
  }

  function snapLive() {
    if (!stream || !liveCameraOk || snapping || pendingBlob || files.length >= maxFiles) return;
    snapping = true;
    if (shutter) shutter.classList.add('is-flash');

    var w = video.videoWidth || 1280;
    var h = video.videoHeight || 960;
    var scale = 1;
    var longEdge = Math.max(w, h);
    if (longEdge > MAX_EDGE) scale = MAX_EDGE / longEdge;
    var cw = Math.max(1, Math.round(w * scale));
    var ch = Math.max(1, Math.round(h * scale));
    canvas.width = cw;
    canvas.height = ch;
    canvas.getContext('2d').drawImage(video, 0, 0, cw, ch);

    function doneFlash() {
      if (shutter) shutter.classList.remove('is-flash');
      snapping = false;
    }

    if (canvas.toBlob) {
      canvas.toBlob(
        function (blob) {
          doneFlash();
          if (!blob) {
            setStatus('Could not capture. Try again.', 'error');
            updateChrome();
            return;
          }
          showReviewFromBlob(blob);
        },
        'image/jpeg',
        JPEG_Q
      );
    } else {
      fetch(canvas.toDataURL('image/jpeg', JPEG_Q))
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          doneFlash();
          showReviewFromBlob(blob);
        })
        .catch(function () {
          doneFlash();
          setStatus('Could not capture. Try again.', 'error');
          updateChrome();
        });
    }
  }

  if (shutter) {
    shutter.addEventListener('click', function (e) {
      e.preventDefault();
      snapLive();
    });
  }
  if (reviewKeep) {
    reviewKeep.addEventListener('click', function (e) {
      e.preventDefault();
      keepPending();
    });
  }
  if (reviewRetake) {
    reviewRetake.addEventListener('click', function (e) {
      e.preventDefault();
      retakePending();
    });
  }
  function openFilePicker() {
    if (!filesInput) return;
    autoOpenCamera = false;
    filesInput.value = '';
    filesInput.click();
  }

  if (filesBtn) {
    filesBtn.addEventListener('click', function () {
      openFilePicker();
    });
  }
  if (filesInput) {
    filesInput.addEventListener('change', function () {
      addFiles(filesInput.files);
    });
  }
  if (takePhotoBtn) {
    takePhotoBtn.addEventListener('click', function () {
      autoOpenCamera = true;
      openNativeCamera();
    });
  }
  if (captureInput) {
    captureInput.addEventListener('change', function () {
      var list = captureInput.files;
      if (!list || !list.length) {
        autoOpenCamera = false;
        setStatus('');
        return;
      }
      var file = list[0];
      if (!isAllowedFile(file)) {
        setStatus('Images only from camera.', 'error');
        return;
      }
      compressImageFile(file).then(function (compressed) {
        showReviewFromBlob(compressed);
      });
    });
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      autoOpenCamera = false;
      files = [];
      clearPendingReview();
      renderPreviews();
      setStatus('');
    });
  }

  if (dropzone) {
    function prevent(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function (ev) {
      dropzone.addEventListener(ev, prevent);
    });
    dropzone.addEventListener('dragenter', function () { dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragover', function () { dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragover'); });
    dropzone.addEventListener('drop', function (e) {
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });
    dropzone.addEventListener('click', function () {
      openFilePicker();
    });
    dropzone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openFilePicker();
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      autoOpenCamera = false;
      setStatus('');

      if (honeypot && honeypot.value) {
        setStatus('Sent \u2014 thanks.', 'ok');
        return;
      }
      if (!files.length) {
        setStatus('Add at least one invoice photo or PDF first.', 'error');
        return;
      }
      if (!endpoint) {
        setStatus('Send isn\u2019t configured yet. Photos stay queued on this page.', 'error');
        return;
      }

      var fd = new FormData();
      fd.append('company_website', (honeypot && honeypot.value) || '');
      fd.append('name', '');
      fd.append('venue', ((venueInput && venueInput.value) || '').trim());
      fd.append('note', ((noteInput && noteInput.value) || '').trim());
      fd.append('page_url', window.location.href);
      fd.append('user_agent', navigator.userAgent || '');
      files.forEach(function (file, i) {
        fd.append('photos', file, file.name || 'invoice-' + (i + 1) + '.jpg');
      });

      if (submitBtn) submitBtn.disabled = true;
      if (shutter) shutter.disabled = true;
      setStatus('Sending ' + files.length + '\u2026');

      fetch(endpoint, { method: 'POST', body: fd, mode: 'cors', credentials: 'omit' })
        .then(function (res) {
          return res.text().then(function (text) {
            var msg = text;
            try {
              var json = JSON.parse(text);
              if (json && (json.detail || json.message || json.ok)) {
                msg = json.detail || json.message || (json.ok ? 'Sent \u2014 thanks.' : text);
              }
            } catch (err) {}
            if (!res.ok) throw new Error(msg || 'Send failed (' + res.status + ')');
            return msg || 'Sent \u2014 thanks.';
          });
        })
        .then(function (msg) {
          setStatus(msg, 'ok');
          files = [];
          clearPendingReview();
          renderPreviews();
          if (noteInput) noteInput.value = '';
        })
        .catch(function (err) {
          setStatus(
            (err && err.message) ||
              'Could not send. Try again or email accounts@plantpantry.com.au',
            'error'
          );
        })
        .finally(function () {
          updateChrome();
        });
    });
  }

  window.addEventListener('pagehide', function () {
    autoOpenCamera = false;
    clearCameraWatch();
    stopLiveCamera();
  });

  updateChrome();

  if (isPhone) {
    prepareVideoEl();
    if (takePhotoBtn) takePhotoBtn.hidden = false;
    startLiveCamera();
  } else {
    if (takePhotoBtn) takePhotoBtn.hidden = true;
    if (shutter) {
      shutter.hidden = true;
      shutter.disabled = true;
    }
  }
})();
